import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import ShimmerButton from './ShimmerButton';
import './NavigationBar.css';

const NavigationBar = () => {
  const [expanded, setExpanded] = React.useState(false);
  const location = useLocation();

  const handleNavClick = (e) => {
    if (e.currentTarget.getAttribute('href') === '/') {
      // Immediately hide without animation
      const navbarCollapse = document.querySelector('.navbar-collapse');
      navbarCollapse.classList.remove('collapsing');
      navbarCollapse.classList.remove('show');
      setExpanded(false);
    } else {
      // Normal animated collapse for other links
      setExpanded(false);
    }
  };

  return (
    <div className="nav-wrapper">
      <Navbar className="floating-nav" expand="xl" expanded={expanded}>
        <Container className="nav-container">
          <Navbar.Brand as={Link} to="/" className="brand-logo" onClick={handleNavClick}>
            <img 
              src="/navlogo.png" 
              alt="ADCI Logo" 
              className="brand-logo-img"
            />
            <div className="brand-text-wrapper">
              <div className="brand-text">ADCI</div>
              <div className="brand-subtext">Anees Defence Career Institute</div>
            </div>
          </Navbar.Brand>
          
          <Navbar.Toggle 
            aria-controls="basic-navbar-nav" 
            className="hamburger-toggle"
            onClick={() => setExpanded(!expanded)}
          />
          
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="nav-links-container">
              <div className="nav-menu-items">
                <Nav.Link as={Link} to="/" onClick={handleNavClick} className={location.pathname === '/' ? 'active' : ''}>
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to="/about" onClick={handleNavClick} className={location.pathname === '/about' ? 'active' : ''}>
                  About Us
                </Nav.Link>
                <Nav.Link as={Link} to="/updates" onClick={handleNavClick} className={location.pathname === '/updates' ? 'active' : ''}>
                  Updates
                </Nav.Link>
                <Nav.Link as={Link} to="/competitive-exams" onClick={handleNavClick} className={location.pathname === '/competitive-exams' ? 'active' : ''}>
                  Competitive Exams
                </Nav.Link>
                <Nav.Link as={Link} to="/gallery" onClick={handleNavClick} className={location.pathname === '/gallery' ? 'active' : ''}>
                  Gallery
                </Nav.Link>
              </div>
              <div className="nav-button">
                <Link to="/contact" onClick={handleNavClick}>
                  <ShimmerButton>Join Us</ShimmerButton>
                </Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavigationBar;
